import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageParameters } from '../storage.service';
import { ApiBase } from './api.base';
import { FoundationPartner } from '../../models/foundation-partner';
import { UserLogin } from '../../models/user-login';
import { Auction } from '../../models/auction';
import { AuctionMapper } from '../../mappers/auction.mapper';
import { map } from 'rxjs/operators';
import { AuctionState } from '../../enum/auction-state.enum';
import { AuctionResultState } from '../../enum/auction-result-state.enum';
export class FoundationPartnersApi extends ApiBase {
  model = 'foundation-partners';

  public create(data: FoundationPartner): Observable<FoundationPartner> {
    return this.http.post<FoundationPartner>(
      this.buildUrl(),
      data,
      {
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    );
  }

  public getByCredentials(username?: string): Observable<UserLogin> {
    let params = new HttpParams();
    if (username) params = params.append('username', username);
    return this.http.get<UserLogin>(
      this.buildUrl('partner-credentials'),
      {
        params,
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    );
  }

  public patch(id: string, data?: FoundationPartner): Observable<FoundationPartner> {
    return this.http.patch<FoundationPartner>(
      this.buildUrl(id),
      data,
      {
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    );
  }

  public getPartnerAuctions(
    userLoginId: string,
    options: {
      skip?: string;
      limit?: string;
      order?: string;
      q?: string;
      state?: AuctionState | AuctionState[];
      items?: 'true';
    } = {}
  ) {
    const params = new HttpParams({ fromObject: options });
    return this.http.get<Auction[]>(
      this.buildUrl(userLoginId, 'auctions'),
      {
        params,
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    )
      .pipe(map(AuctionMapper.mapItems));
  }

  public getTotalAuctions(
    userLoginId: string,
    options: {
      q?: string;
      state?: AuctionState | AuctionState[];
    } = {}
  ) {
    if (!userLoginId) throw 'UserLogin Id required';
    const params = new HttpParams({ fromObject: options });
    return this.http.get<{total: number}>(
      this.buildUrl(userLoginId, 'auctions', 'total'),
      {
        params,
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    )
  }

  public getAuctionResults(
    userLoginId: string,
    auctionId: string,
    options: {
      skip?: number;
      limit?: string;
      order?: string;
      q?: string;
      state?: AuctionResultState | AuctionResultState[];
    } = {}
  ) {
    const params = new HttpParams({ fromObject: options });
    return this.http.get<{total: number, items:Auction[]}>(
      this.buildUrl(userLoginId, 'auction-results', auctionId),
      {
        params,
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    );
  }

  public hasPendingResults(
    userLoginId: string,
    auctionId: string,
  ) {
    return this.http.get<boolean>(
      this.buildUrl(userLoginId, 'has-pending-results', auctionId),
      {
        headers: this.setHeaders({
          'Authorization': this.getStorage().getItem(StorageParameters.AccessTokenId)
        })
      },
    )
  }

}
